<!-- Error Views -->
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="d-flex flex-column w-100 h-100" *ngIf="dataLoadSuccess && !noData">
    <!-- Row limit warning -->
    <sol-inline-notification *ngIf="isLimitNotificationShown"
        style="margin-top: -12px !important;"
        class="ml-2 mr-2"
        type="info"
        [message]="limitNotificationMessage"
        [show]="isLimitNotificationShown"
        (close)="closeLimitNotification()">
    </sol-inline-notification>

    <div class="currentAgentStates d-flex flex-row w-100 h-100 align-items-stretch" style="overflow-y: auto;">
        <!-- Table -->
        <cv-current-agent-states-cxone-table class="equalFill" *ngIf="localizationsLoaded && !noData && getActiveView() !== 'chart'" 
            [moduleManager]="moduleManager" 
            [sharedData]="sharedData" 
            [showFilter]="_filterBarShowing"
            [_stateToColorMap]="_stateToColorMap"
            [moduleKey]="moduleKey">
        </cv-current-agent-states-cxone-table>
    
        <div class="view-divider m-2" *ngIf="localizationsLoaded && !noData && getActiveView() === 'dual'"></div>
        <!-- Chart -->
        <cv-current-agent-states-cxone-graph class="equalFill" *ngIf="localizationsLoaded && !noData && getActiveView() !== 'table'"
            [sharedData]="sharedData"
            [_stateToColorMap]="_stateToColorMap">
        </cv-current-agent-states-cxone-graph>
    
        <div *ngIf="sharedData.IncompatibleSettings" class="incompatible-overlay position-absolute w-100 h-100 font-weight-bold" style="z-index: 2; background-color: rgba(0,0,0,0.80); top: 0; left: 0;">
            <div class="position-absolute" style="width: 75%; text-align: center; color: #ffffff; font-size: 16px; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            </div>
        </div>
    </div>
</div>
